import React, { useState, useEffect } from "react";
import "./index.scss";
import { getPhone } from "../../../../utils/msg";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

function Electronic() {
    const { t } = useTranslation();
    const history = useHistory();
    const language = localStorage.getItem("i18nextLng");
    const advantageContent = t("residency.space_part4", {
      returnObjects: true,
    });
    const clickTo = () => {
      history.push(`/aboutUs`);
    };
  return (
    <div className="advantage_">
      <div className="advantage_introduce">
        <div className="advantage_int_con">
          <div className="advantage_int_title">{advantageContent.introduceTitle}</div>
          <div className="advantage_int_content">{advantageContent.introduceContent}</div>
        </div>
      </div>
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{advantageContent.title}</div>
        </div>
      </div>
      <div className="advantage_con">
        {advantageContent.list?.map((item0, index0) => {
          return (
            <div className="advantage_li" key={index0}>
              <div className="advantage_li_box">
                <div className="advantage_li_img">
                  <img src={item0.iconUrl} alt="" />
                </div>
                <div className="advantage_li_text">
                  <div className="advantage_li_til">{item0.itemTitle}</div>
                  <div className="advantage_li_con">{item0.itemContent}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="advantage_other">
        <div className="advantage_other_con">
          <div className="advantage_oth_left">
              <div className="advantage_oth_l_title">{advantageContent.otherInfo.title}</div>
              <div className="advantage_oth_l_content">{advantageContent.otherInfo.content}</div>
          </div>
          <div className="advantage_oth_right" onClick={()=>clickTo()}>
            {advantageContent.otherInfo.btnText}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Electronic;
